import initVirtualSearchBox from './widgets/virtualSearchBox';

const initWidgets = algoliaSearch => {
	initVirtualSearchBox(algoliaSearch);
};

export default initWidgets;
